import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import {
  Typography,
  DrawerContent,
  DrawerActions,
  Button,
  VStack,
  HStack,
} from "@smartrent/ui";
import {
  Form,
  FormSelectField,
  FormSwitch,
  FormSubmit,
} from "@smartrent/forms";
import * as Yup from "yup";

interface CMWFeatureFlagFormProps {
  title: string;
  flagOptions: Array<{ value: string; label: string }>;
  initialValues: Record<string, any>;
  validationSchema: Yup.AnyObjectSchema;
  onSubmit: (values: any) => Promise<void>;
  onCancel: () => void;
  additionalFields?: React.ReactNode;
  enabledAssistiveText?: string;
}

export function CMWFeatureFlagForm({
  title,
  flagOptions,
  initialValues,
  validationSchema,
  onSubmit,
  onCancel,
  additionalFields,
  enabledAssistiveText = "Whether the feature is enabled or not",
}: CMWFeatureFlagFormProps) {
  return (
    <Form
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <>
        <DrawerContent>
          <ScrollView>
            <View style={styles.container}>
              <Typography type="title3">{title}</Typography>
              <VStack spacing={16} style={styles.content}>
                {additionalFields}
                <FormSelectField
                  name="featureFlag"
                  label="Select Feature Flag"
                  options={flagOptions}
                  required
                />
                <FormSwitch
                  name="enabled"
                  label="Enabled"
                  assistiveText={enabledAssistiveText}
                />
              </VStack>
            </View>
          </ScrollView>
        </DrawerContent>
        <DrawerActions>
          <HStack spacing={8} style={styles.buttonRow}>
            <Button
              size="small"
              variation="plain"
              onPress={onCancel}
              style={styles.flex1}
            >
              Cancel
            </Button>
            <View style={styles.flex1}>
              <FormSubmit size="small" label="Save" />
            </View>
          </HStack>
        </DrawerActions>
      </>
    </Form>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 0,
  },
  content: {
    marginTop: 16,
  },
  buttonRow: {
    width: "100%",
  },
  flex1: {
    flex: 1,
  },
});
